export default __webpack_public_path__ + "static/media/login.0b23eb87.svg";